import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "./Third.css";
import first from "../../../../Asset/indus/ShipTime.png";
import second from "../../../../Asset/indus/Welnes.png";
import third from "../../../../Asset/indus/MovieRanker.png";
import fourth from "../../../../Asset/indus/Finfolio.png";
import fifth from "../../../../Asset/indus/Tuki.png";
import sixth from "../../../../Asset/indus/Paid.png";
import shiptime from "../../../../Asset/indus/Shiptime-image.png";
import welness from "../../../../Asset/indus/Welnes-image.png";
import movie from "../../../../Asset/indus/Movieranker-image.png";
import finfolio from "../../../../Asset/indus/Finfolio-image.png";
import tuki from "../../../../Asset/indus/Tuki-image.png";
import paid from "../../../../Asset/indus/Paid-image.png";
import { useNavigate } from "react-router-dom";

const industriesData = [
  {
    key: "logistic",
    title: "Shiptime",
    description:
      "Shiptime is an online shipping platform designed exclusively for all small and medium-sized businesses, whether it’s domestic or international. Here you can compare rates and services from multiple carriers. This is an all-in-one stop to manage your shipping needs effortlessly.",
    features: [
      "Domestic and International shipping",
      "Courier integrations",
      "E-commerce integration",
    ],
    logo: first,
    image: shiptime,
    backgroundColor: "var(--light-primary-bg)",
  },
  {
    key: "healthcare",
    title: "Welnes",
    description:
      "Welnes is an online healthcare platform. It offers you the best nutritionists and professional workout trainers, plus a customized diet program according to your health requirements. So you can stay at your home, and still be productive enough to take care of your health.",
    features: [
      "User Registration and Challenge Selection",
      "Challenge-Based Activities",
      "Motivational Timeline",
      "In-App User Interaction",
      "Point System and Leaderboard",
      "Challenge Management",
      "Manage Content",
      "Live Streaming",
      "Content Sharing",
      "Group Customization",
    ],
    logo: second,
    image: welness,
    backgroundColor: "var(--light-primary-bg)",
  },
  {
    key: "entertainment",
    title: "MovieRanker",
    description:
      "Movie Ranker the name itself suggest this platform is for movie enthusiast. You can discover a variety of new movies, theater movies, preview movie trailers, movie news, and more. You can also connect with other movie enthusiasts to discuss, share, and recommend your favorite films.",
    features: [
      "Customizable Search Filters",
      "Sorting Options",
      "Recommendation System",
      "User Profiles",
      "Community Interaction",
      "Forum and Discussion Board",
      "Connectivity",
      "Private and Public Recommendations",
    ],
    logo: third,
    image: movie,
    backgroundColor: "var(--light-primary-bg)",
  },
  {
    key: "fintech",
    title: "FinFolio",
    description:
      "FinFolio is a portfolio management software for wealth management professionals. It brings together all your accounts from different custodians, letting you run reports, access firm-level data on dashboards, trade, bill clients, set up portals, and handle various tasks in real-time.",
    features: [
      "Master Security List",
      "Integrations",
      "Composites",
      "Trading Setup",
      "Report Setup",
    ],
    logo: fourth,
    image: finfolio,
    backgroundColor: "var(--light-primary-bg)",
  },
  {
    key: "hrms",
    title: "Tuki",
    description:
      "Tuki is an all-in-one online platform designed to empower businesses in the food service and hospitality industry with efficient scheduling, staffing, and support. Which Addresses various HR and operational aspects for shift-based businesses.",
    features: [
      "Staff Management",
      "Ratings and Feedback",
      "Communication",
      "Real-Time Analytics",
      "Authentication and Security",
      "Mobile Application",
      "Offline Mode with Data Sync",
    ],
    logo: fifth,
    image: tuki,
    backgroundColor: "var(--light-primary-bg)",
  },
  {
    key: "ecommerce",
    title: "Paid",
    description:
      "Paid app is a dream come true for all business owners. It is a B2B Ultimate Business solution and payment platform for business owners as it enables them to handle everything at a single platform without the extra hustle and worries.",
    features: [
      "Payment Gateway",
      "Facilitate the creation of dynamic websites",
      "Invoicing",
      "Shipping Functionality",
      "Integration",
      "Mobile App: Point of Sale (POS)",
      "Invoicing Management",
    ],
    logo: sixth,
    image: paid,
    backgroundColor: "var(--light-primary-bg)",
  },
];

const Third = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("logistic");
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleTabClick = (tab) => {
    if (tab !== activeTab) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab(tab);
        setIsTransitioning(false);
      }, 100);
    }
  };

  const activeIndustry = industriesData.find(
    (industry) => industry.key === activeTab
  );
  return (
    <>
      <section
        className="third-extra-indus-section"
        style={{ background: "var(--white-color)" }}
      >
        <Container>
          <div className="top-text-after-fourth-services">
            <h2>
              850+ PROJECTS DELIVERED & <span> COUNTING...</span>
            </h2>
          </div>
          <div className="row align-items-start">
            <div className="col-lg-3 col-xl-3">
              <div className="align-items-start industry-tab-sec">
                <ul className="nav flex-column nav-pills me-3 industris-list">
                  {industriesData.map((industry) => (
                    <li
                      key={industry.key}
                      className={`nav-link d-block text-left w-100 ${
                        activeTab === industry.key ? "active" : ""
                      }`}
                      onClick={() => handleTabClick(industry.key)}
                    >
                      {industry.key.charAt(0).toUpperCase() +
                        industry.key.slice(1)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-9 col-xl-9">
              <div className="main-slider">
                <div
                  className={`industries-content-wrapper d-flex flex-wrap p-5 myclass ${
                    isTransitioning ? "fade-out" : "fade-in"
                  }`}
                  style={{ backgroundColor: activeIndustry.backgroundColor }}
                >
                  <div className="industry-partner-wrapper w-50 pr-3">
                    <img
                      src={activeIndustry.logo}
                      alt="indusImage"
                      className="company_logo"
                    />
                    <div className="industry-partner-text">
                      <h4>
                        <b>{activeIndustry.title}</b>
                      </h4>
                      <p>{activeIndustry.description}</p>
                      <div className="info-cta">
                        <span
                          className="btn btn-primary"
                          onClick={() => {
                            navigate("/portfolio");
                          }}
                        >
                          Read More
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="industries-detail d-flex w-50 pl-lg-3 mt-0">
                    <div className="industries-detail-img">
                      <img
                        alt="indusImage"
                        src={activeIndustry.image}
                        className="w-100"
                      />
                    </div>
                  </div>
                  <div className="industry-portfolio-feature">
                    <h4 className="pb-1">
                      <b>Features:</b>
                    </h4>
                    <div className="feature-card-element d-flex flex-wrap">
                      {activeIndustry.features.map((feature, index) => (
                        <div key={index} className="feature-card m-0">
                          {feature}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
